import { Outlet, useLocation } from 'react-router-dom';
import { cn } from '../services/lib/utils';

const PUBLIC_ROUTES_WITH_GRADIENT = ['/login', '/register', '/reset-password'];

export function UnprotectedLayout() {
  const { pathname } = useLocation();
  const hasGradientBackground = PUBLIC_ROUTES_WITH_GRADIENT.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );

  return (
    <div
      className={cn(
        'relative h-screen overflow-y-auto [@supports(height:100dvh)]:min-h-[100dvh]',
        hasGradientBackground && 'bg-people-gradient',
      )}>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[200] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:font-medium focus:outline-none focus:ring-2 focus:ring-primary-600">
        Skip to main content
      </a>
      <main id="main" tabIndex={-1} className="relative flex min-h-full flex-col">
        {hasGradientBackground && (
          <img
            src="/background_vectors.svg"
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute left-0 right-0 top-0 w-full object-contain object-top opacity-50"
          />
        )}
        <div className="flex min-h-full flex-1 flex-col items-center justify-center">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
